import React from "react";
import { Link } from "react-router-dom";

import "./styles/logo.css";

// Inline SVG monogram. Rendered in the DOM (not via <img>), so it can use the
// site's loaded Playfair heading font and the same navy-to-blue gradient as the
// page headlines. Scales crisp at any size and fits the circular logo badge.
const Logo = (props) => {
	let { width, link } = props;
	if (width === undefined) width = 46;
	if (link === undefined) link = true;

	const mark = (
		<svg
			className="logo"
			width={width}
			height={width}
			viewBox="0 0 100 100"
			shapeRendering="geometricPrecision"
			role="img"
			aria-label="Swapnil Tamse"
		>
			<defs>
				<linearGradient
					id="st-logo-gradient"
					x1="0"
					y1="0"
					x2="1"
					y2="1"
				>
					<stop offset="0%" stopColor="#2d3748" />
					<stop offset="100%" stopColor="#3182ce" />
				</linearGradient>
			</defs>
			<circle cx="50" cy="50" r="49" fill="url(#st-logo-gradient)" />
			<text
				x="50"
				y="50"
				textAnchor="middle"
				dominantBaseline="central"
				fontFamily="'Playfair Display', Georgia, serif"
				fontSize="46"
				fontWeight="600"
				letterSpacing="1"
				fill="#ffffff"
			>
				ST
			</text>
		</svg>
	);

	return link ? <Link to="/">{mark}</Link> : mark;
};

export default Logo;
